import axios from "axios";
import * as Constants from "./Constants";
import qs from "qs";
import { BASE_API_URL, REFRESH_TOKEN, LOGIN } from "./ApiUrls";
import { Auth } from "./Common";
import RecaptchaTokenResolver from "./RecaptchaTokenResolver";

class HttpService {

    constructor() {
        this.getAuthData = null;
        this.setAuthData = null;

        this.http = axios.create({
            baseURL: BASE_API_URL
            //withCredentials: true,
        });

        this.http.interceptors.request.use(async (request) => {
            if (request.data) {
                var token = process.env.REACT_APP_RECAPTCHA_TOKEN;
                request.headers[Constants.RECAPTCHA_HEADER_KEY] = token;
            }
            return request;
        });

        this.http.interceptors.response.use(
            response => {
                return response;
            }, ((error) => {
                
                if (error.config.url.indexOf(LOGIN) === -1 && !error.config.isRetried && error.response.status === 401) {
                    const expired = error.response.headers["Token-Expired"] == "true";

                    if (expired) {
                        const data = this.getAuthData();

                        if (data) {
                            const { token, refreshToken } = data;
                            const http = this.http;
                            error.config.isRetried = true;

                            return http.postJsonAsync(REFRESH_TOKEN, { token, refreshToken })
                                    .then(res => {
                                        Auth.set(res.data);
                                        this.setAuthData(res.data);
                                        error.config.headers.Authorization = `bearer ${res.data.token}`;
                                        return http.request(error.config);
                                    });
                        }
                    }
                }
                return window.Promise.reject(error);
            }).bind(this));
    }

    getAsync(url, params, needAuth = true, header = {}) {

        const request = this._getRequest(needAuth, false, header);
        request.params = params;
        return this.http.get(url, request);
    }

    _getRequest(needAuth, isPost, header = {}) {
        const request = {
            validateStatus: function (status) {
                return status >= 200 && status < 300; // default
            },
            headers: {...header}
        };

        let auth = this.getAuthData();
        if (auth) {
            if (isPost) {
                request.headers[auth.requestTokenHeader] = auth.requestToken;
            }
            if (needAuth) {
                request.headers["Authorization"] = `bearer ${auth.token}`;
            }
        }
        return request;
    }

    postJsonAsync(url, data, needAuth = true, headers = null) {

        return this.http.post(url, data, this._getRequest(needAuth, true, headers));
    }
    putJsonAsync(url, data, needAuth = true, headers = null) {

        return this.http.put(url, data, this._getRequest(needAuth, true, headers));
    }


    postFormUrlEncodedAsync(url, data, needAuth = true) {
        const request = this._getRequest(needAuth, true);
        request.headers["content-type"] = "application/x-www-form-urlencoded";
        request.data = qs.stringify(data);

        return this.http.post(url, request);
    }

    postFormDataAsync(url, formData, onUploadProgress, needAuth = true) {
        if (!(formData instanceof FormData)) {
            throw Error("fromData must be type of 'FormData'");
        }

        const request = this._getRequest(needAuth, true);
        request.headers["content-type"] = "multipart/form-data";
        request.onUploadProgress = onUploadProgress || (e => console.log(e.loaded));
        //request.formData = formData;

        return this.http.post(url, formData, request);
    }

    putFormDataAsync(url, formData, onUploadProgress, needAuth = true) {
        if (!(formData instanceof FormData)) {
            throw Error("fromData must be type of 'FormData'");
        }

        const request = this._getRequest(needAuth, true);
        request.headers["content-type"] = "multipart/form-data";
        request.onUploadProgress = onUploadProgress || (e => console.log(e.loaded));

        return this.http.put(url, formData, request);
    }
}

export default new HttpService();


// WEBPACK FOOTER //
// ./src/common/HttpService.js